<script setup lang="ts">
// KDM adapter around the generic EditableAxisLabel: reloads the KDM matrix
// after a rename. Keeping this thin wrapper lets all KDM call sites stay
// unchanged while the rename logic lives in one place (EditableAxisLabel).
import {Axis} from "#/KrrNode";
import {kdm, loadKdm} from "@/store/kdm";
import EditableAxisLabel from "@/components/EditableAxisLabel.vue";

defineProps<{
  axis: Axis,
  canEdit: boolean,
  linkClass?: string | (string | false | undefined)[],
  iconStroke?: string,
  target?: string,
  title?: string,
}>();

function onRenamed() {
  if (kdm.value?.nid) loadKdm(String(kdm.value.nid));
}
</script>

<template>
  <EditableAxisLabel v-bind="$props" @renamed="onRenamed">
    <template #actions><slot name="actions"/></template>
  </EditableAxisLabel>
</template>
